import React, { Fragment, useState, useEffect } from "react";
import Topbar from "../layouts/TopBar";
import AbsenceResources from "../resources/AbsenceResources";
import moment from "moment/moment";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { connect } from "react-redux";
import { logout } from "../redux/actions/LoggedInAction";
import {ACCESS_DENIED} from '../Messages'
import toast from 'react-hot-toast'

function ManageMyAbsences({isLoggedIn, loggedInUser}){
  const [absences, setAbsences] = useState([])
  const [editingId, setEditingId] = useState(null)
  const [editStartDate, setEditStartDate] = useState('')
  const [editEndDate, setEditEndDate] = useState('')
  const [editReason, setEditReason] = useState('')

  const absenceResources = new AbsenceResources()

    const loadMyAbsences = () => {
        return absenceResources.get_my_absences()
    }

    const handleEdit = (absence) => {
        setEditingId(absence['id'])
        setEditStartDate(moment(absence['start_date']).format('YYYY-MM-DD'))
        setEditEndDate(moment(absence['end_date']).format('YYYY-MM-DD'))
        setEditReason(absence['reason'] || '')
    }

    const handleCancelEdit = () => {
        setEditingId(null)
    }

    const handleSaveEdit = (absence) => {
        let body = {}
        body['user_id'] = absence['user_id']
        body['start_date'] = editStartDate + ' 00:00:00'
        body['end_date'] = editEndDate + ' 23:59:59'
        body['reason'] = editReason

        absenceResources.put_by_id(absence['id'], body).then(res => {
            if (res.error && res.error.length > 0) {
                toast.error(res.error)
            } else {
                toast.success("Absence updated successfully")
                setEditingId(null)
                loadMyAbsences().then(response => {
                    setAbsences(response['body'])
                })
            }
        }).catch((err) => {
            toast.error("Network Error: " + err)
        })
    }

    const handleDelete = (absence) => {
        const confirmed = window.confirm("Are you sure you want to delete this absence?")
        if (!confirmed) return

        absenceResources.delete_my_absence({ id: absence['id'] }).then(res => {
            if (res.error && res.error.length > 0) {
                toast.error(res.error)
            } else {
                toast.success("Absence deleted successfully")
                setAbsences(absences.filter(a => a['id'] !== absence['id']))
            }
        }).catch((err) => {
            toast.error("Network Error: " + err)
        })
    }

    useEffect(() => {
        loadMyAbsences().then(response => {
            setAbsences(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });
    }, []);

    const getAbsenceStatus = (absence) => {
        const today = moment().startOf('day')
        const start = moment(absence['start_date']).startOf('day')
        const end = moment(absence['end_date']).startOf('day')
        if (end.isBefore(today)) return 'past'
        if (start.isAfter(today)) return 'upcoming'
        return 'active'
    }

    return(
        <Fragment>
            <Topbar/>

            <div className="hero-area">
            <div className="page-banner parallax" style={{backgroundColor:"#003165"}}>
                    <div className="container">
                        <div className="page-banner-text">
                        {isLoggedIn ?
                                <h1 style={{color:"#ffa800"}} className="block-title"><strong>My Absences</strong></h1>
                                :
                                <h1 style={{color:"#ffa800"}} className="block-title"><strong>{ACCESS_DENIED}</strong></h1>
                            }

                        </div>
                    </div>
                </div>
            </div>

            <div id="main-container">
                {
                    isLoggedIn ?

                <div className="content">
                    <div className="container">
                        <div className="spacer-40"></div>

                        <div style={{backgroundColor: '#e8f4fd', border: '1px solid #b8daff', borderRadius: '8px', padding: '14px 18px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap'}}>
                            <i className="fa fa-info-circle" style={{color: '#003165', fontSize: '18px'}}></i>
                            <span style={{color: '#003165', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>
                                Want to add a new absence? <a href="/requestabsence" style={{color: '#ffa800', fontWeight: 'bold', textDecoration: 'underline'}}>Request an absence here</a>
                            </span>
                        </div>

                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                <TableRow>
                                    <TableCell><strong>Start Date</strong></TableCell>
                                    <TableCell><strong>End Date</strong></TableCell>
                                    <TableCell><strong>Reason</strong></TableCell>
                                    <TableCell><strong>Status</strong></TableCell>
                                    <TableCell><strong>Actions</strong></TableCell>
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {absences.map((absence) => (
                                    <TableRow key={absence['id']}>
                                        {editingId === absence['id'] ? (
                                            <>
                                                <TableCell>
                                                    <input
                                                        type="date"
                                                        value={editStartDate}
                                                        max={moment().format('YYYY-MM-DD')}
                                                        onChange={(e) => setEditStartDate(e.target.value)}
                                                        style={{padding: '4px 8px'}}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <input
                                                        type="date"
                                                        value={editEndDate}
                                                        onChange={(e) => setEditEndDate(e.target.value)}
                                                        style={{padding: '4px 8px'}}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <input
                                                        type="text"
                                                        value={editReason}
                                                        onChange={(e) => setEditReason(e.target.value)}
                                                        placeholder="Reason"
                                                        style={{padding: '4px 8px', width: '200px'}}
                                                    />
                                                </TableCell>
                                                <TableCell></TableCell>
                                                <TableCell>
                                                    <button
                                                        style={{backgroundColor: "#8ccd80", color: "#003165", marginRight: "8px", padding: '4px 12px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold'}}
                                                        onClick={() => handleSaveEdit(absence)}
                                                    >Save</button>
                                                    <button
                                                        style={{backgroundColor: "#ccc", color: "#003165", padding: '4px 12px', border: 'none', borderRadius: '4px', cursor: 'pointer'}}
                                                        onClick={handleCancelEdit}
                                                    >Cancel</button>
                                                </TableCell>
                                            </>
                                        ) : (
                                            <>
                                                <TableCell>{moment(absence['start_date']).format('DD MMMM YYYY')}</TableCell>
                                                <TableCell>{moment(absence['end_date']).format('DD MMMM YYYY')}</TableCell>
                                                <TableCell>{absence['reason'] || '-'}</TableCell>
                                                <TableCell>
                                                    {(() => {
                                                        const status = getAbsenceStatus(absence)
                                                        const colorMap = { upcoming: '#007bff', active: '#28a745', past: '#666' }
                                                        return (
                                                            <span style={{ color: colorMap[status], fontWeight: 'bold' }}>
                                                                {status.charAt(0).toUpperCase() + status.slice(1)}
                                                            </span>
                                                        )
                                                    })()}
                                                </TableCell>
                                                <TableCell>
                                                    {getAbsenceStatus(absence) !== 'past' && (
                                                        <>
                                                            <button
                                                                style={{backgroundColor: "#ffa800", color: "#fff", marginRight: "8px", padding: '4px 12px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold'}}
                                                                onClick={() => handleEdit(absence)}
                                                            >Edit</button>
                                                            <button
                                                                style={{backgroundColor: "#d80000", color: "#fff", padding: '4px 12px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold'}}
                                                                onClick={() => handleDelete(absence)}
                                                            >Delete</button>
                                                        </>
                                                    )}
                                                </TableCell>
                                            </>
                                        )}
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        {absences.length === 0 && (
                            <div style={{
                                textAlign: 'center',
                                padding: '40px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '10px',
                                marginTop: '20px'
                            }}>
                                <p style={{color: '#666', fontSize: '18px'}}>
                                    No absences recorded
                                </p>
                            </div>
                        )}

                        <div className="spacer-40"></div>
                    </div>
                </div> : <></>
        }
            </div>

        </Fragment>
    )
}

const mapStateToProps = (state) => {
    return{
       isLoggedIn: state.authReducer.isLoggedIn,
       loggedInUser: state.authReducer.user
    };

};

const mapDispatchToProps = {
    logout
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageMyAbsences);
